import "./Card.css";
import bugbounty from "./bb.jpeg";

function Card() {
    return (
      <div className="Activitiescardcss">
        <img className="ActImage" src={bugbounty} alt={""}></img>
      </div>
    );
  }
  
export default Card;